// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"8b1440eb","787":"6e5d88d3"}[chunkId] + ".chunk.js";
};